import { findCountryCode } from "./findCountryCode";
import { findCountryPhoneCode } from "./findCountryPhoneCode";
import { removePhoneCodePrefix } from "./removePhoneCodePrefix";

/**
 * @param phoneNumber - full phone number
 * @returns [phoneNumberWithoutPrefix, countryCode]
 */
export const getNumberWithoutPefixAndCountryCode = (phoneNumber: string): [string | null, string | null] => {
  const countryCode = findCountryCode(phoneNumber);
  if (!countryCode) {
    return [null, null];
  }

  const countryPhoneCode = findCountryPhoneCode(countryCode);
  if (!countryPhoneCode) {
    return [null, countryCode];
  }

  const phoneNumberWithoutPrefix = removePhoneCodePrefix(phoneNumber, countryPhoneCode);

  return [phoneNumberWithoutPrefix, countryCode];
};
